module.exports = __webpack_public_path__ + "img/rugbyleague.0b477e95.svg";